module.exports = __webpack_public_path__ + "img/logo_3.d299cf8f.svg";